import { useQuery } from '@tanstack/react-query'
import { getDatasetsQuery } from '@global/api'
import { IDatasetQueryArgs } from '../../api/types'
import { MakeQueryOptionsDtoArgs } from '../../api/types/queryOptions'
import { AxiosError } from 'axios'

export const KEY = 'datasetsDataQuery'

export const DEFAULT_PARAMS = {
  hasCommentSupport: false,
  limit: 1000,
  offset: 0,
  queryOptionsByFieldId: {},
  refetchDatasetNum: 0,
  refetchDatasetRefNum: 0,
}

interface Params {
  datasetId: string
  queryOptionsByFieldId: MakeQueryOptionsDtoArgs['optionsByFieldId']
  offset: number
  limit: number
  hasCommentSupport: boolean
  refetchDatasetNum: number
  refetchDatasetRefNum: number
  classificationCategoryIds?: number[]
}

interface IArgs {
  params: Params
  queryParams: IDatasetQueryArgs
}

export const useDatasetDataQuery = ({ params, queryParams }: IArgs) => {
  const isSelectivePath = Boolean(window.location.pathname.includes('selective'))

  return useQuery({
    queryKey: [KEY, params],
    queryFn: ({ signal }) =>
      getDatasetsQuery({
        ...queryParams,
        axiosOptions: { signal },
      }).catch((error: unknown) => {
        // we have cases where the server returns 404, but is intended
        // so we swallow the error on the FE as not to disrupt the user experience
        // TODO: error handling the FE/BE contract needs an overhaul
        if (!(error instanceof AxiosError) || error.status !== 404) {
          throw error
        }
      }),
    enabled: !isSelectivePath,
  })
}
